export const arrayToQueryParams = (items: Array<string | number>, name: string) => {
  return items.reduce(
    (params, item, index) => ({
      ...params,
      [`${name}[${index}]`]: item,
    }),
    {},
  );
};
